export const isNode = false;
export const isBrowser = true;
